import React from 'react';

import { ProfileImage } from '@xingternal/profile-image';

import { useBreakpoints } from '@/hooks';

import { useHeaderContext } from '../../../context';
import { CompanyLink } from '../company-link';

export const CompanyLogo: React.FC = () => {
  const { companyName, logo } = useHeaderContext();
  const { isMobile } = useBreakpoints();

  return (
    <CompanyLink>
      <ProfileImage
        size={isMobile ? 'small' : 'medium'}
        profileName={companyName}
        type="company"
        src={logo || undefined}
        data-testid="company-logo"
      />
    </CompanyLink>
  );
};
